/* No checkout interception; cart/account routes remain native Shopify links. */
(() => {
  document.addEventListener('click', (event) => {
    const menu = document.querySelector('.pz-mobile-menu[open]');
    if (!menu) return;
    if (!menu.contains(event.target) || event.target.closest('a')) menu.removeAttribute('open');
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.pz-mobile-menu[open]');
    if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
  });
})();

/* v9: progressive motion; content remains visible if JS/observers are unavailable. */
(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const active = new Set();
  let observer;
  const finish = () => { active.forEach(animation => animation.cancel()); active.clear(); };
  const reveal = (element) => {
    if (seen.has(element)) return;
    seen.add(element);
    if (preference.matches || typeof element.animate !== 'function') return;
    const animation = element.animate([
      { opacity: .85, transform: 'translateY(8px)' },
      { opacity: 1, transform: 'translateY(0)' }
    ], { duration: 420, easing: 'cubic-bezier(.2,.7,.3,1)' });
    active.add(animation);
    animation.onfinish = animation.oncancel = () => active.delete(animation);
  };
  const initialize = (root = document) => {
    if (preference.matches || !('IntersectionObserver' in window)) return;
    if (!observer) observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        reveal(entry.target);
      });
    }, { threshold: .08 });
    root.querySelectorAll('section.pz > .pz-wrap, .pz-product-shell .product__info-wrapper').forEach(element => {
      if (!seen.has(element)) observer.observe(element);
    });
  };
  const changed = () => { if (preference.matches) { if (observer) observer.disconnect(); finish(); } else initialize(); };
  if (preference.addEventListener) preference.addEventListener('change', changed);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
})();
